import { config } from '@/pageConfig/lemonadeGoesGlobal/nl/nl';
import { LemonadeGoesGlobalPageTemplate } from '@/pageTemplate/LemonadeGoesGlobalPageTemplate';
import type { Data } from '@/pageTemplate/LemonadeGoesGlobalPageTemplate';
import { getAvailabilityByRegion } from '@/utils/getAvailabilityByRegion';

export default function LemonadeGoesGlobalPage({ data }: { data: Data }) {
  return <LemonadeGoesGlobalPageTemplate config={config} data={data} locale="nl-NL" />;
}

export async function getStaticProps() {
  return await getAvailabilityByRegion();
}
